<script lang="ts">
	import { appName } from "../../../../core/schema/names/appName.js";
	import logo from "../../../../core/assets/logo.svg";
	import type { Image } from "../../../../core/schema/Image.js";
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import Icon from "../Icon.svelte";
	import camera from "../../../../core/assets/icons/camera.svg?raw";

	export let product: ProductForCustomer;
	export let images: Image[];
	export let containerClass = "";
	export { containerClass as class };

	const { TENANT_LOCALE } = getGlobalSettings();

	$: [primaryImage, ...otherImages] = images;

	$: displayedImage = primaryImage;

	function displayImage(image: Image): void {
		displayedImage = image;
	}

	function displayPrimaryImage(): void {
		displayedImage = primaryImage;
	}

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="relative {containerClass}">
	{#if displayedImage}
		<DynamicPicture
			class="md:max-h-[37rem] md:max-w-[37rem]"
			imgClass="w-full h-full rounded-lg aspect-square object-cover"
			image={displayedImage}
			lightboxId={product.name[TENANT_LOCALE]}
			lightboxWidth={800}
			width={600}
			height={600}
			bucket="storage"
			loading="eager"
			alt="Fotografie – {product.name[TENANT_LOCALE]} (1/{images.length})"
		/>
	{:else}
		<div
			class="bg-secondary-40 flex aspect-square h-auto max-h-[37rem] w-full max-w-[37rem] items-center justify-center rounded-md"
		>
			<StaticPicture
				alt="Logo {appName}"
				image={logo}
				class="w-28 opacity-50 lg:w-36 xl:w-40"
				loading="eager"
				width={160}
				height={160}
			/>
		</div>
	{/if}
	<div class="mt-4 grid grid-cols-4 gap-4">
		{#each otherImages as image, i}
			{#if i < 4}
				<DynamicPicture
					class="max-h-[8.625rem] max-w-[8.625rem] hover:max-h-[37rem] hover:max-w-[37rem]"
					imgClass="w-full h-full rounded-lg"
					{image}
					lightboxId={product.name[TENANT_LOCALE]}
					lightboxWidth={800}
					width={600}
					height={600}
					bucket="storage"
					loading="eager"
					alt="Fotografie – {product.name[TENANT_LOCALE]} ({i + 2}/{images.length})"
					on:mouseover={() => {
						displayImage(image);
					}}
					on:mouseout={displayPrimaryImage}
				/>
			{/if}
		{/each}
	</div>
	{#if images.length > 0}
		<p class="text-secondary-300 text-2xs mt-6 flex hidden w-[21.5625rem] items-center font-normal leading-4">
			<Icon icon={camera} class="mr-2 inline-block w-8" />
			<span class="text-secondary-300 text-2xs w-full font-normal leading-4">
				Fotografie jsou ilustrační, zdobení se může lišit podle aktuálního uměleckého cítění našich cukrářek.
			</span>
		</p>
	{/if}
</div>
